<aca-page-layout>
  <div class="aca-page-layout-header">
    <h1 class="aca-page-title">{{ 'APP.BROWSE.TRASHCAN.TITLE' | translate }}</h1>
    <aca-toolbar [items]="actions"></aca-toolbar>
  </div>

  <div class="aca-page-layout-content">
    <div class="aca-main-content">
      <adf-document-list
        #documentList
        acaDocumentList
        acaContextActions
        [currentFolderId]="'-trashcan-'"
        [selectionMode]="'multiple'"
        [multiselect]="false"
        [navigate]="false"
        [sortingMode]="'client'"
        [imageResolver]="imageResolver"
        [sorting]="['archivedAt', 'desc']"
        [isResizingEnabled]="true"
        [blurOnResize]="false"
      >
        <adf-custom-empty-content-template>
          <adf-empty-content icon="delete" [title]="'APP.BROWSE.TRASHCAN.EMPTY_STATE.TITLE'">
            <p class="adf-empty-content__text">
              {{ 'APP.BROWSE.TRASHCAN.EMPTY_STATE.FIRST_TEXT' | translate }}
            </p>
            <p class="adf-empty-content__text">
              {{ 'APP.BROWSE.TRASHCAN.EMPTY_STATE.SECOND_TEXT' | translate }}
            </p>
          </adf-empty-content>
        </adf-custom-empty-content-template>

        <data-columns>
          <ng-container *ngFor="let column of columns; trackBy: trackByColumnId">
            <ng-container *ngIf="column.template && !(column.desktopOnly && isSmallScreen)">
              <data-column
                [id]="column.id"
                [key]="column.key"
                [draggable]="column.draggable"
                [resizable]="column.resizable"
                [title]="column.title"
                [type]="column.type"
                [format]="column.format"
                [class]="column.class"
                [sortable]="column.sortable"
                [isHidden]="column.isHidden"
              >
                <ng-template let-context>
                  <adf-dynamic-column [id]="column.template" [context]="context"> </adf-dynamic-column>
                </ng-template>
              </data-column>
            </ng-container>

            <ng-container *ngIf="!column.template && !(column.desktopOnly && isSmallScreen)">
              <data-column
                [id]="column.id"
                [key]="column.key"
                [title]="column.title"
                [type]="column.type"
                [format]="column.format"
                [class]="column.class"
                [sortable]="column.sortable"
                [draggable]="column.draggable"
                [resizable]="column.resizable"
                [isHidden]="column.isHidden"
              >
              </data-column>
            </ng-container>
          </ng-container>

          <data-column
            *ngIf="!isSmallScreen && (user$ | async)?.isAdmin"
            class="adf-ellipsis-cell"
            key="archivedByUser.displayName"
            title="APP.DOCUMENT_LIST.COLUMNS.DELETED_BY"
          >
          </data-column>
        </data-columns>
      </adf-document-list>

      <adf-pagination acaPagination [target]="documentList"> </adf-pagination>
    </div>
  </div>
</aca-page-layout>
